export const NotificationConstants = {
  ITEM_ADDED_TEXT: 'Item has been added to cart',
  ADDED: 'Item has been added to cart',
  REDUCED: 'Item quantity decreased',
  INCREASED: 'Item quantity increased',
  REMOVED: 'Item removed from the cart',
  UPDATED: 'Cart has been updated',
  DETAILS_PREFIX: ' | Style #: ',
  SUCCESS_ICON: '../../../assets/icons/svg/new-tick-icon.svg',
  CART_TEXT: 'Total sample in the cart:',
  CART_CLOSE_ICON: '../../../assets/icons/svg/compare-close-icon.svg',
  CLOSE_ICON: '../../../assets/icons/svg/close-icon.svg',
  USER_DOES_NOT_EXIST: 'User does not exist',
  NO_ACCOUNT_FOUND_FOR_THAT_EMAIL: 'No account found for that email',
  OTP_EXPIRED: 'OTP expired',
  SOMETHING_WENT_WRONG: 'Something went wrong'
};
